import { render, staticRenderFns } from "./OrderTotal.vue?vue&type=template&id=02cde2f0&"
import script from "./OrderTotal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderTotal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OrderTotal.vue?vue&type=style&index=0&id=02cde2f0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderPromoCode: require('/usr/www/nuxt/components/Order/OrderPromoCode.vue').default})
